import React from 'react'

const Contact = () => {
  const address = "3376 White Oak Rd Unit 19, London, ON N6E 2Z9";
  const phoneDisplay = "(226) 456-1820";
  const phoneTel = "+12264561820";

  return (
    <main className=" bg-gray-50">
      
      <section className="border-b bg-white">
        <div className="mx-auto max-w-6xl px-4 py-10">
          <h1 className="text-3xl font-bold text-gray-900">Contact Us</h1>
          <p className="mt-2 max-w-2xl text-gray-600">
            Visit us or give us a call. We’re happy to help with quotes and bookings.
          </p>
        </div>
      </section>

      
      <section className="mx-auto max-w-6xl px-4 py-12">
        <div className="grid gap-8 md:grid-cols-2">
          {/* Contact Info */}
          <div className="space-y-6">
            <div className="rounded-2xl border border-gray-200 bg-white p-8 shadow-sm">
              <h2 className="text-xl font-semibold text-gray-900">Location</h2>
              <p className="mt-2 text-gray-600">{address}</p>

              <h2 className="mt-6 text-xl font-semibold text-gray-900">Phone</h2>
              <p className="mt-2 text-gray-600">{phoneDisplay}</p>

              <div className="mt-6 flex flex-wrap gap-3">
                <a
                  href={`tel:${phoneTel}`}
                  className="inline-flex items-center justify-center rounded-xl bg-gray-900 px-5 py-2.5 text-sm font-semibold text-white hover:bg-gray-800 transition"
                >
                  Call Now
                </a>

                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                    address
                  )}`}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center justify-center rounded-xl border border-gray-300 bg-white px-5 py-2.5 text-sm font-semibold text-gray-900 hover:bg-gray-50 transition"
                >
                  Get Directions
                </a>
              </div>
            </div>

            <div className="rounded-2xl border border-gray-200 bg-white p-8 shadow-sm">
              <h2 className="text-xl font-semibold text-gray-900">Hours</h2>
              <p className="mt-2 text-gray-600">
                Monday – Friday: 9:30 AM – 5:00 PM
                <br />
                Saturday - Sunday : Appointments Only.
                </p>
            </div>
          </div>

          
          <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
            <h2 className="px-4 pt-4 text-xl font-semibold text-gray-900">
              Find Us on the Map
            </h2>

            <div className="mt-4 overflow-hidden rounded-2xl border border-gray-200">
             
              <div className="aspect-video w-full">
                <iframe
                  title="Trusted Wrench Location"
                  src={`https://www.google.com/maps?q=${encodeURIComponent(
                    address
                  )}&output=embed`}
                  className="h-full w-full"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>

            <p className="px-4 pb-4 pt-4 text-sm text-gray-600">
              {address}
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Contact